import React from 'react';
import s from './solutions-grid.scss';
import { SolutionGridWrapper } from '../../../solution-grid-wrapper/solution-grid-wrapper';
import { composer } from '../../../../component-decorators/composer';
import type { WithTranslation as WithTranslationProps } from 'react-i18next';
import { Card, Heading } from '@wix/design-system';
import type { GUID } from '@wix/bi-logger-market/v2/types';

export interface ISolutionsGridProps extends Partial<WithTranslationProps> {
  solutions: any;
  collimp_id?: GUID;
  referralSectionName?: string;
  referralInfo?: string;
}

export const SolutionsGrid = composer()
  .withTranslation()
  .compose((props: ISolutionsGridProps) => {
    return (
      <Card className={s.suggestionsSection}>
        <Heading
          appearance="H2"
          className={s.suggestionsTitle}
          dataHook="solutions-grid-title"
        >
          {props.t('solution.page.YouMayAlsoLike')}
        </Heading>
        <SolutionGridWrapper
          solutions={props.solutions}
          isCompany
          colSpan={4}
          isFull={true}
          referralSectionName={
            props.referralSectionName
              ? props.referralSectionName
              : 'may-also-like'
          }
          collimp_id={props.collimp_id}
          referralInfo={props.referralInfo}
        />
      </Card>
    );
  });
